import React from 'react';

function PlayCircle() {
  /* eslint-disable max-len */
  return (
    <svg viewBox="0 0 24 24">
      <path d="M9.6 17.4l7.2-5.4-7.2-5.4v10.8zM12 0C5.376 0 0 5.376 0 12s5.376 12 12 12 12-5.376 12-12S18.624 0 12 0zm0 21.6c-5.292 0-9.6-4.308-9.6-9.6S6.708 2.4 12 2.4s9.6 4.308 9.6 9.6-4.308 9.6-9.6 9.6z" />
    </svg>
  );
  /* eslint-enable */
}

export default PlayCircle;



// WEBPACK FOOTER //
// ./src/common/icons/PlayCircle.js